<div class="main-container" data-cy="note-main-container">
  <div class="action-ctonainer" data-cy="note-main-action-container">
    <button mat-button color="primary"
            [disabled]="startupWithoutParams"
            class="filter-button"
            *ngIf="!filteredMode && !hideFilterButton"
            (click)="hideFilters = !hideFilters"
            matTooltip="{{ hideFilters ? 'Show filters' : 'Hide filters' }}"
            [class.active-button]="!hideFilters"
            data-cy="note-main-filter-toggle">
      <i class="material-icons">filter_list</i>
    </button>
    <div class="patient-name-display" data-cy="note-main-patient-name">{{ PatientName }}</div>
    <!--<button mat-button color="primary" disabled><i class="material-icons">print</i></button>
  <button mat-button color="primary" disabled><i class="material-icons">share</i></button>-->
    <button mat-button color="primary" [disabled]="startupWithoutParams" (click)="deleteMode = !deleteMode;" [class.active-button]="deleteMode" data-cy="note-main-delete-mode-toggle"><i class="material-icons">delete</i></button>
    <button mat-button color="primary" [disabled]="startupWithoutParams" (click)="createNoteGroup()" data-cy="note-main-add-note"><i class="material-icons">note_add</i></button>
    <button mat-button (click)="onCloseClick()" data-cy="note-main-close-button"><i class="material-icons text-danger">close</i></button>
  </div>
  <mat-divider data-cy="note-main-divider"></mat-divider>

  <div class="filter-container" *ngIf="!isLoading && !hideFilters" data-cy="note-main-filter-container">
    <h4 class="filters-header" data-cy="note-main-filters-header">Filters</h4>
    <button mat-icon-button (click)="hideFilters = true" class="close-filter-internal-button" data-cy="note-main-close-filter">
      <i class="material-icons close-filter-icon">close</i>
    </button>

    <div *ngIf="dataNoteCategoryEnums && dataNoteTypeEnums" data-cy="note-main-filter-options">
      <div class="show-all-container" data-cy="note-main-show-all-container">
        <mat-checkbox (change)="onShowAllFilterClick()" [(ngModel)]="showAllFilter.selected" data-cy="note-main-show-all-checkbox">
          {{ showAllFilter.displayValue }}
        </mat-checkbox>
      </div>

      <app-tdo-multiselect-dropdown #categorySelector
                                    placeholder="Category Filter"
                                    [items]="dataNoteCategoryEnums.enumValidValueItems"
                                    [selectedItems]="selectedCategories"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onCategoryChanged($event)"
                                    data-cy="note-main-category-filter">
      </app-tdo-multiselect-dropdown>

      <app-tdo-multiselect-dropdown #typeSelector
                                    placeholder="Types"
                                    [items]="dataNoteTypeEnums.enumValidValueItems"
                                    [selectedItems]="selectedTypes"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onTypesChanged($event)"
                                    data-cy="note-main-type-filter">
      </app-tdo-multiselect-dropdown>

      <app-tdo-multiselect-dropdown #objectSelector
                                    placeholder="Related Objects"
                                    [items]="objectsRelatedToPatient"
                                    [selectedItems]="selectedRelatedObjects"
                                    valueExp="ObjectId"
                                    [multiple]="false"
                                    displayExp="ObjectDescription"
                                    (onChange)="onRelatedObjectsChanged($event)"
                                    data-cy="note-main-related-objects-filter">
      </app-tdo-multiselect-dropdown>

    </div>
  </div>

  <div class="note-groups-container" [class.draw-outline]="!hideFilters" *ngIf="!isLoading" data-cy="note-main-groups-container">
    <div class="note-group" *ngFor="let noteGroup of dataNoteGroups" data-cy="note-main-group">
      <div *ngIf="deleteMode" data-cy="note-main-delete-container">
        <button mat-button color="warn" class="delete-group-button" (click)="deleteNoteGroup(noteGroup)" data-cy="note-main-delete-group-button"><i class="material-icons">delete</i></button>
      </div>
      <app-note-viewer *ngIf="noteGroup.display" [editable]="true"
                       [dataNote]="noteGroup.dataNote" [dataNoteCategoryEnums]="dataNoteCategoryEnums"
                       [dataNoteTypeEnums]="dataNoteTypeEnums"
                       data-cy="note-main-viewer">
      </app-note-viewer>
      <mat-divider *ngIf="noteGroup.display" class="note-divider" data-cy="note-main-note-divider"></mat-divider>
    </div>
    <div class="no-notes-message" *ngIf="!dataNoteGroups || !dataNoteGroups.length" data-cy="note-main-no-notes">
      No notes found
    </div>
  </div>

  <div class="spinnder-div" *ngIf="isLoading" data-cy="note-main-loading-container">
    <div class="spinner-holder" data-cy="note-main-spinner-holder">
      <mat-spinner data-cy="note-main-spinner"></mat-spinner>
    </div>
  </div>
</div>
